import { PropsWithChildren } from "react";
import { twMerge } from "tailwind-merge";

export const MonotoneContainer = (
  props: PropsWithChildren<{ className?: string }>
) => {
  return (
    <div
      className={twMerge(
        "bg-[#F2F2F2] overflow-hidden rounded-3xl text-center flex flex-col",
        // 縦方向の制約に合わせて横幅を調整
        "h-[90%] max-h-[638px]",
        // アスペクト比を維持しながら縦に収まるように調整
        "w-full max-w-md",
        // 縦方向に見切れる場合は横幅を縮小
        "min-h-0 aspect-[384/638]",
        // コンテナクエリを使用してレスポンシブ対応
        "@container",
        props.className
      )}
      style={{
        // 縦の制約がある場合は横幅を自動調整
        width: "min(100%, min(28rem, 90vh * 384 / 638))",
        height: "min(90%, 638px)",
      }}
    >
      {props.children}
    </div>
  );
};
